var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('customer-company')],1),_c('b-col',[_c('customer-tax-no')],1),_c('b-col',[_c('customer-tax-office')],1),_c('b-col',[_c('customer-phone')],1),_c('b-col',[_c('customer-address')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }